import React, { Component } from "react";
import { Field } from "formik";
import CheckField from "./fields/CheckField";
import { Fieldset } from "../theme/styled";
import { injectIntl } from "react-intl";

class FieldsMultisport extends Component {
  render() {
    const { intl } = this.props;
    return (
      <Fieldset>
        <h2>Multisport</h2>
        <Field name="arena" component={CheckField} label="Arena" />
        <Field
          name="wicketArena"
          component={CheckField}
          label={intl.formatMessage({
            id: "multisport.wicketArena",
            defaultMessage: "Furtka do areny",
          })}
        />
        <Field
          name="football"
          component={CheckField}
          label={intl.formatMessage({
            id: "multisport.football",
            defaultMessage: "Piłka nożna",
          })}
        />
        <Field
          name="badmintonLines"
          component={CheckField}
          label={intl.formatMessage({
            id: "multisport.badmintonLines",
            defaultMessage: "Linie do badmintona",
          })}
        />
      </Fieldset>
    );
  }
}

export default injectIntl(FieldsMultisport);
